export const submissionReassignmentsContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
